const CicClosureReason = {
  Unknown: 0,
  Processed: 1,
  Expired: 2
};

export default CicClosureReason;
